import { inject, injectable } from 'inversify';
import OrdersRepository from 'src/features/orders/data/OrdersRepository';
import { CreateOrderParams } from 'features/orders/data/service/OrdersService.types.ts';
import { PaymentMethodSlug } from 'src/types/common';

export interface CreatePariTransferOrderUseCaseParams
  extends Omit<CreateOrderParams, 'payment_method'> {}

@injectable()
class CreatePariTransferOrderUseCase {
  @inject(OrdersRepository) private ordersRepository!: OrdersRepository;

  async execute(params: CreatePariTransferOrderUseCaseParams) {
    return await this.ordersRepository.createOrder({
      ...params,
      payment_method: PaymentMethodSlug.PariTransfer,
    });
  }
}

export default CreatePariTransferOrderUseCase;
